<template>
    <v-layout column v-if="stats && stats.geozoneTypes">      
      <v-layout>
        <top-info-panel style="height: 120px;">
          <v-flex xs12 md12 lg6 xl5 px-2  slot="content" >
              <h4>{{title}} </h4>
              <button @click="test">OPEN</button>
              <!-- <p>U heeft <strong>3</strong> nieuwe berichten. <strong>12</strong> brandstoftanks, <strong>2</strong> autos geven een waarschuwing</p>           -->
          </v-flex>
        </top-info-panel>
      </v-layout>
      <transition 
           enter-active-class="fadeInLeft"
           leave-active-class="fadeOutRight"
           mode="out-in"
      >
      <v-layout wrap px-3 align-center justify-center class="" style="z-index:10;" v-if="!selectedDetails" >
        <v-flex sm12 style="margin-top:-20px;">
          <v-layout fluid wrap >
            <v-flex sm12 md12 lg8 >
              <v-layout wrap> 
                <v-flex sm12 md6 lg3 px-2 d-flex>   
                      <small-dashboard-card 
                        icon-color="#8BC34A" 
                        icon="fas fa-broadcast-tower"
                        d-flex >
                        <div slot="number">
                            <animated-number
                            :value="stats.connectivity.devicesConnected"                            
                            :duration="800"
                            :round="1"
                            />
                           / <span style="color: #f44336;">
                              <animated-number
                                :value="stats.connectivity.devicesNotConnected"                            
                                :duration="800"
                                :round="1"
                                />
                             </span></div>
                        <div slot="title">Connected assets</div>
                    </small-dashboard-card>
                </v-flex>
                <v-flex sm12 md6 lg3 px-2 d-flex>                         
                      <small-dashboard-card 
                        icon-color="#E91E63" 
                        icon="far fa-building"
                        d-flex 
                        @click.native="selectedDetails = 'ownLocations'"
                        style="cursor: pointer;"
                        >
                        <div slot="number">
                           <animated-number
                            :value="stats.geozoneTypes.ownLocations"                            
                            :duration="800"
                            :round="1"
                          />
                        </div>
                        <div slot="title">Eigen locaties</div>
                    </small-dashboard-card>
                </v-flex>

                <v-flex sm12 md6 lg3 px-2 d-flex>   
                      <small-dashboard-card 
                        icon-color="#2196F3" 
                        icon="fas fa-wrench"
                        d-flex >
                        <div slot="number">
                          <div slot="number">
                           <animated-number
                            :value="stats.geozoneTypes.customerLocations"                            
                            :duration="800"
                            :round="1"
                          />
                        </div>
                        </div>
                        <div slot="title">Klantlocatie</div>
                    </small-dashboard-card>
                </v-flex>
                <v-flex sm12 md6 lg3 px-2 d-flex>   
                      <small-dashboard-card 
                        icon-color="#CDDC39" 
                        icon="fas fa-car"
                        d-flex >
                        <div slot="number">                          
                           <animated-number
                            :value="(stats.geozoneTypes.totalMobileAssets - stats.geozoneTypes.customerLocations - stats.geozoneTypes.ownLocations)"                            
                            :duration="800"
                            :round="1"
                          />  
                        </div>
                        <div slot="title">Onderweg</div>
                    </small-dashboard-card>
                </v-flex>
                <v-flex sm12 md12 lg12 px-2 mt-2 d-flex>
                  <v-widget  
                    class="mt-2" 
                    :elevation="2" 
                    title="Laatste gebeurtenissen (24 uur)">
                    <v-flex slot="widget-content">     
                      <v-flex v-if="lastEvents.length == 0" d-flex class="no-data-label">
                        Er zijn de afgelopen 24 uur geen gebeurtenissen geregistreerd.
                      </v-flex>              
                      <table v-else style="width: 100%;">
                        <tr v-for="e of lastEvents" :key="e.id">
                          <td class="event-type-td" style="width: 30px;">
                            <div class="event-type-block" :style="`background-color: ${color(e.event.eventType.internalName)}`"></div>
                          </td>
                          <td style="width: 100px;">
                            {{e.timestamp | time}}
                          </td>
                          <td>
                            {{e.asset.name}}
                          </td>
                          <td>
                            <span v-if="e.address">{{e.address.street}}</span>
                            <span v-else><i>Geen adres</i></span>
                          </td>
                           <td style="text-align:center;">
                            {{e.shortText}}
                          </td>
                          <!-- <td>
                            <span v-if="e.address"><span :class="streetTypeClass(e.address.street)">{{e.address.street.replace(/;/g," ")}}</span> </span>
                            <span v-else><i>Geen adres</i></span>
                            
                          </td>
                          <td>
                              <span v-if="e.address" class="ml-2 road-city-type">{{e.address.city}}</span>
                          </td> -->
                        </tr>
                      </table>
                    </v-flex>
                  </v-widget>                    
                </v-flex>
                <v-flex sm12 md12 lg12 px-2 mt-2 d-flex>
                  <v-widget  
                    class="mt-2" 
                    :elevation="2" 
                    title="Laatste acties (24 uur)">
                    <v-flex slot="widget-content"  >                  
                      <v-flex v-if="lastActions.length == 0" d-flex class="no-data-label">
                        Er zijn de afgelopen 24 uur geen acties geregistreerd.
                      </v-flex>             
                      <v-flex v-else d-flex class=" d-flex">
                        Er zijn de afgelopen 24 uur geen acties geregistreerd.
                      </v-flex>             
                    </v-flex>
                  </v-widget>  
                </v-flex>
                <!-- <v-flex sm12 md12 lg6 px-2 mt-2 d-flex>
                  <v-card class="red lighten-1 white--text" d-flex>                    
                    <v-card-text style='min-height: 100px; display: flex; align-content: center; align-items: center; justify-content:center; flex:1; font-size: 1.1vw;'>                  
                        
                        <div>km file</div>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex sm12 md6 lg3 px-2 mt-2 d-flex>
                  <v-card class="light-green white--text" d-flex>                    
                    <v-card-text style='min-height: 100px;' >                  
                      
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex sm12 md6 lg3 px-2 mt-2 d-flex>
                  <v-card  d-flex>                    
                    <v-card-text style='min-height: 100px;' >                  
                      
                    </v-card-text>
                  </v-card>
                </v-flex> -->
              </v-layout>
            </v-flex>
            <v-flex sm12 md12 lg4 d-flex>
              <v-layout column >
                <dashboard-asset-status :statusses="stats.statusses">
                </dashboard-asset-status>
                <v-widget 
                  class="mt-2"
                  :elevation="2"
                  title="Top POI's"
                >
                  <v-flex slot="widget-content">
                    <table style="width: 100%;" v-if="stats.topGeozones.length > 0">
                      <tr v-for="zone of stats.topGeozones" :key="zone.geo_zone_id">
                        <td style="width: 200px;">{{zone.name}}</td>
                        <td> 
                          <v-progress-linear
                            :color="colorOnPercentage(((zone.amount / stats.topGeozones[0].amount) * 100))"
                            height="5"
                            :value="((zone.amount / stats.topGeozones[0].amount) * 100)"
                          ></v-progress-linear>
                        </td>
                        <td style="width: 40px; text-align:center;">{{zone.amount}}</td>
                      </tr>
                      
                    </table>
                  </v-flex>
                </v-widget>
                <v-card d-flex style="min-height: 400px;" class="mt-2">
                   <l-map 
                    style="min-height: 400px;"
                    v-if="assets.length > 0"               
                    :zoom="zoom"
                    :center="center"          
                    :bounds="assetCoordinates"                    
                    >
                    <LeafletHeatmap :lat-lng="assetCoordinates" :max="1" :radius="20" :min-opacity="0.4"></LeafletHeatmap>

                    <l-tilelayer :url="url" :attribution="attribution"></l-tilelayer>
                  </l-map>
                </v-card>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
        <!-- <v-flex sm12 style="margin-top:-20px;">
          <v-layout>
            <v-flex sm12 md3 lg2 px-2 d-flex>   
                <small-dashboard-card 
                  icon-color="#8BC34A" 
                  icon="fas fa-broadcast-tower"
                  d-flex >
                  <div slot="number">301 / <span style="color: #ccc;">320</span></div>
                  <div slot="title">Connected assets</div>
              </small-dashboard-card>
            </v-flex>
            <v-flex sm12 md3 lg2 px-2 d-flex>  
                <small-dashboard-card 
                  icon-color="#8BC34A" 
                  icon="far fa-thumbs-up"
                  
                  d-flex >
                  <div slot="number">301</div>
                  <div slot="title">OK</div>
              </small-dashboard-card>
            </v-flex>
            <v-flex sm12 md3 lg2 px-2 d-flex>  
                <small-dashboard-card 
                  icon-color="#FF9800" 
                  icon="fas fa-exclamation-triangle"
                  
                  d-flex >
                  <div slot="number">11</div>
                  <div slot="title">Waarschuwing</div>
              </small-dashboard-card>
            </v-flex>
            <v-flex sm12 md3 lg2 px-2 d-flex>  
                <small-dashboard-card 
                  icon-color="#F44336" 
                  icon="fas fa-exclamation-circle"
                  
                  d-flex >
                  <div slot="number">11</div>
                  <div slot="title">Fout</div>
              </small-dashboard-card>
            </v-flex>
            <v-flex sm12 md3 lg2 px-2 d-flex>  
                <small-dashboard-card 
                  icon-color="#9C27B0" 
                  icon="far fa-life-ring"
                  
                  d-flex >
                  <div slot="number">3</div>
                  <div slot="title">Fout met actie</div>
              </small-dashboard-card>
            </v-flex>
            <v-flex sm12 md3 lg2 px-2 d-flex>  
                <small-dashboard-card 
                  icon-color="#2196F3" 
                  icon="fas fa-wrench"
                  
                  d-flex >
                  <div slot="number">4</div>
                  <div slot="title">Actie</div>
              </small-dashboard-card>
            </v-flex>
          </v-layout>
        </v-flex> -->
        
      </v-layout>
      <asset-overview-by-geo-zone 
        v-else-if="selectedDetails == 'ownLocations'" 
        @close="selectedDetails = null" 
        closeLabel="Terug naar dashboard"
        title="Overzicht van assets op eigen locaties"
        :geozoneTypes="['own_locations']">
        
      </asset-overview-by-geo-zone>
      
      </transition>
      
    </v-layout>
</template>
<script>
import Vue2Leaflet from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import { mapGetters } from 'vuex'
import { MAP_URL, IMAGE_URL } from "../config.js";
import * as types from '../store/types'
import VWidget from "../components/global/VWidget"
import DdTooltip from '../components/global/DdTooltip'
import TopInfoPanel from '../components/global/TopInfoPanel'
import SmallDashboardCard from '../components/graph/SmallDashboardCard'
import DashboardAssetStatus from '../components/graph/DashboardAssetStatus'
import AssetOverviewByGeoZone from '../components/overview/AssetOverviewByGeoZone'
import LeafletHeatmap from 'vue2-leaflet-heatmap'
import AnimatedNumber from "animated-number-vue";
import moment from 'moment'
import ColorMixin from '../plugins/mixins/ColorMixin.js'

export default{
  mixins:[ColorMixin],
  components:{
    VWidget,
    DdTooltip,
    TopInfoPanel,
    SmallDashboardCard,
    DashboardAssetStatus,
    LeafletHeatmap,
    AnimatedNumber,
    AssetOverviewByGeoZone,
    "l-map": Vue2Leaflet.LMap,
    "l-tilelayer": Vue2Leaflet.LTileLayer,
    "l-marker": Vue2Leaflet.LMarker,
    "l-group": Vue2Leaflet.LLayerGroup,
    "l-popup": Vue2Leaflet.LPopup,
    "l-polyline": Vue2Leaflet.LPolyline,
    "l-tooltip": Vue2Leaflet.LTooltip,
    "l-control-zoom": Vue2Leaflet.LControlZoom
  },
  data() {
    return  {
        showButton:true,
        zoom: 7,
        url: MAP_URL, //'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        center: [52,6],
        bounds: null,
        mapOptions: { zoomControl: false },    
        selectedDetails: false  
    }
  },  
  computed: {
    ...mapGetters({
      currentUser: types.CURRENT_USER,
      assets: types.MAP_ASSETS,
      stats:types.DASHBOARD_STATS,
      lastActions: types.ACTIONS_HISTORIC,
      lastEvents: types.EVENTS_HISTORIC
    }),   
    assetCoordinates(){

      // return[
      //   [52,6],
      //   [52,6],
      //   [52,6],
      //   [52,6],
      //   [52,6],
      //   [52,6.002],
      //   [52.2,6.1],
      //   [52.4,6.2],
      // ]

      if(this.assets){
        let coordinates = this.assets.map((ele) => {
          if(ele.lat && ele.lon){
            return [ele.lat, ele.lon];
          }
          
        })

        coordinates = coordinates.filter(ele => ele)
        return coordinates
      }
      return []
    },
    title(){
      let currentdate = new Date();
      let currentHour = parseInt(currentdate.getHours())
      let daytime = "";

      if(currentHour >= 0 && currentHour < 6){
        daytime = "nacht"
      }
      else if(currentHour >= 6 && currentHour < 12){
        daytime = "morgen"
      }
      else if(currentHour >= 12 && currentHour < 18){
        daytime = "middag"
      }      
      else if( currentHour >= 12 && currentHour < 23){
        daytime = "navond"
      }            

      return "Goede"+daytime+" "+this.currentUser.person.firstName;
    }
  },  
  methods:{
    test(){

    },
    streetTypeClass(street){
      if(street){
        if(street[0] == 'A' && (parseInt(street[1]) > 0)){
          return 'road-a-type'
        }
        if(street[0] == 'E' && (parseInt(street[1]) > 0)){
          return 'road-e-type'
        }
        if(street[0] == 'N' && (parseInt(street[1]) > 0)){
          return 'road-n-type'
        }
        else{
          return 'road-urban-type'
        }
      }
      return '';
    },
    showNotification(message){
        this.$notify(this.message,{color:"error"});
    },
    colorOnPercentage(perc){
      if(perc > 80){
        return 'success'
      }
      if(perc > 20){
        return 'warning'
      }
      
        return 'error'
      
    },
    loadData(){
      this.$store.dispatch(types.MAP_ASSETS, {data: {query: null}, params: { include:'group', 'disablePaging' : true } })

      let fromDate = moment().subtract(1, 'days').format("YYYY-MM-DD")      
  
      this.$store.dispatch(types.DASHBOARD_STATS, {});
      this.$store.dispatch(types.EVENTS_HISTORIC, {data: {'date': fromDate}, params: {include: 'asset,event.eventType,event.eventSeverity,address'}}).then(() => {

      })
      this.$store.dispatch(types.ACTIONS_HISTORIC, {data: {'date': fromDate}});
    }
  },
  mounted(){    
    this.$store.dispatch(types.TOPBAR_DENSE, true);
    this.$store.dispatch(types.BACKGROUND_ICON, 'globe-europe')
    this.loadData()
  },
  beforeDestroy(){
    this.$store.dispatch(types.TOPBAR_DENSE, false);
  }
}
</script>
<style>
  .testing{
    background-color: red;
    color: red;
  }

  .event-type-td{
    
    vertical-align: middle;
  }
  .event-type-block{
    width: 16px;
    height: 16px;
    border-radius: 4px;
    
  }

  
  .road-a-type{
    background-color: #f44336;
    color: #fff;
    padding: 2px 4px;
    border-radius: 5px;
  }

  .road-e-type{
    background-color: green;
    color: #fff;
    padding: 2px 4px;
    border-radius: 5px;
  }

  .road-n-type{
    background-color: #F4DD0D;
    color: #000;
    padding: 2px 4px;
    border-radius: 5px;
  }

  .road-urban-type{
    background-color: #0194e0;
    color: #fff;
    padding: 2px 8px;
    border-radius: 5px;
  }

  .road-city-type{
    background-color: #eee;
    color: #777;
    padding: 2px 8px;
    border-radius: 5px;
  }

  .no-data-label{
    font-size: 18px;
    text-align:center;
    flex: 1;
    justify-content: center;
    
    
  }
  
</style>
